/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.0.0
 */

import type { FC } from 'react';

import Highlighter from 'react-highlight-words';

import { TOverflow } from '@/main/types/globalTypes';
import { EllipseText } from '@components/common';

import { IMultiSelectItem } from '../MultiSelectItemList';
import { StandartSelectListStyled } from './styled/StandardSelectListStyled';

type TStandartSelectListProps = IMultiSelectItem & { tooltipOverflow?: TOverflow, tooltipMaxHeight?: string};

const StandardSelectList: FC<TStandartSelectListProps> = ({ label, searchValue = '', tooltipOverflow, tooltipMaxHeight }) => (
    <StandartSelectListStyled>
        <EllipseText maxHeight={tooltipMaxHeight} overflow={tooltipOverflow} title={label} >
            <Highlighter
                autoEscape={true}
                highlightClassName='multiselect-item__label_highlight'
                searchWords={[searchValue]}
                textToHighlight={label}/>
        </EllipseText>
    </StandartSelectListStyled>
);

export default StandardSelectList;
